

































import { Component, Prop, Vue } from "vue-property-decorator";
import { ROUTE_NAMES } from "../router/routenames";
@Component({})
export default class DoKoTableStats extends Vue {
  @Prop({
    type: Number,
    default: 0,
  })
  private x!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private y!: number;

  get transformText() {
    return `translate(${this.x} ${this.y})`;
  }
  navToRules() {
    this.$router.push({
      name: ROUTE_NAMES.RULES,
    });
  }
  navToTableStats() {
    this.$router.push({
      name: ROUTE_NAMES.TABLESTATS,
    });
  }
}
